import { Award, Download, Lock } from "lucide-react";
import { useApi, BACKEND } from "@/lib/api";

export function WelcomeCertificate() {
  const { data } = useApi("/me/certificate/status");
  if (!data || !data.id_label) return null;
  return (
    <section className="surface relative overflow-hidden p-5 mb-6 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="welcome-certificate-card">
      <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-[#2412B5]/10" /><div className="pointer-events-none absolute right-16 -bottom-12 h-24 w-24 rounded-full bg-[#FF9700]/15" />
      <div className="h-12 w-12 shrink-0 rounded-2xl bg-gradient-to-br from-[#2412B5] to-[#086477] grid place-items-center"><Award className="h-6 w-6 text-white" /></div>
      <div className="flex-1 min-w-0">
        <p className="text-xs muted">{data.id_label}</p>
        <p className="font-mono text-lg font-semibold tracking-wide" data-testid="member-id-value">{data.code || "—"}</p>
        <p className="text-sm muted">{data.eligible ? "Your welcome certificate to the Nirogyam Digital Health Network is ready." : data.reason}</p>
      </div>
      {data.eligible ? <a href={`${BACKEND}/api/me/certificate`} className="relative inline-flex items-center gap-2 rounded-full bg-[#2412B5] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#1C0E93]" data-testid="certificate-download-btn"><Download className="h-4 w-4" />Download certificate</a>
        : <span className="inline-flex items-center gap-1.5 text-xs muted" data-testid="certificate-locked"><Lock className="h-3.5 w-3.5" />Certificate locked</span>}
    </section>
  );
}
